module.exports = __webpack_public_path__ + "media/images/rectangle_mobile-ae7af5c16ec08bdade8b39f5327e4acf.png";